function guidGenerator() {
	var S4 = function() {
	   return (((1+Math.random())*0x10000)|0).toString(16).substring(1);
	};
	return (S4()+S4()+"-"+S4()+"-"+S4()+"-"+S4()+"-"+S4()+S4()+S4());
}

var logo_slider_ids = [];
for (const slider of document.querySelectorAll(".swiper-logo-images")) {
	const id = 'carousel-'+guidGenerator();
	slider.classList.add(id);
	slider.setAttribute('id',id);
	logo_slider_ids.push(id);
}

for (const slider of logo_slider_ids) {
	const swiper = new Swiper('.'+slider, {
		// Optional parameters
		direction: 'horizontal',
		loop: true,
		autoHeight: false,
		slidesPerView: 2.5,
		effect: 'slide',
		spaceBetween: '32',
		autoplay: {
			delay: 2000
		},
		centeredSlides: true,
		breakpoints: {
			640: {
				slidesPerView: 5,
				centeredSlides: false,
			}
		}
	});
}

var icon_slider_ids = [];
for (const slider of document.querySelectorAll(".swiper-icon-points")) {
	const id = 'carousel-'+guidGenerator();
	slider.classList.add(id);
	slider.setAttribute('id',id);
	icon_slider_ids.push(id);
}

for (const slider of icon_slider_ids) {
	const swiper = new Swiper('.'+slider, {
		// Optional parameters
		direction: 'horizontal',
		loop: true,
		autoHeight: false,
		slidesPerView: 1.25,
		effect: 'slide',
		spaceBetween: '32',
		autoplay: {
			delay: 2000
		},
		centeredSlides: true,
		breakpoints: {
			640: {
				spaceBetween: '64',
				slidesPerView: 4,
				centeredSlides: false,
			},
			1180: {
				spaceBetween: '64',
				slidesPerView: 5,
				centeredSlides: false,
			}
		}
	});
}

jQuery(document).ready(function($){
	var mastheadImagesSwiper = new Swiper('.swiper-masthead-images', {
		// Optional parameters
		loop: true,
		speed: 700,
		slidesPerView: 1,
		effect: 'fade',
		fadeEffect: {
			crossFade: true
		},
		autoplay: {
			delay: 2000
		}
	});

	// Off canvas triggers
	$('.off-canvas').on('opened.zf.offcanvas', function(event) {
		$('#nav-header').addClass('stuck');
		$('body').addClass('stuck');
	});
	$('.off-canvas').on('closed.zf.offcanvas', function(event) {
		var closed = true;
		$('.off-canvas').each(function() {
			if ($(this).hasClass('is-open')) {
				closed = false;
			}
		});
		if (closed) {
			$('#nav-header').removeClass('stuck');
			$('body').removeClass('stuck');
		}
	});

	// Add span around last word of title
	$('.hero__title').each(function(index, element) {
            var heading = $(element);
            var word_array, last_word, first_part;

            word_array = heading.html().split(/\s+/); // split on spaces
            last_word = word_array.pop();             // pop the last word
            first_part = word_array.join(' ');        // rejoin the first words together

            heading.html([first_part, ' <span class="last-word">', last_word, '</span>'].join(''));
        });
});